import { FC } from 'react';
import Link from 'next/link';
import cn from 'classnames';
import { useRouter } from 'next/router';
import styles from './HeaderLInks.module.scss';

interface HeaderLInksProps {
  routes: {
    name: string;
    path: string;
    logo: string;
  }[];
}

const HeaderLInks: FC<HeaderLInksProps> = ({ routes }) => {
  const router = useRouter();

  return (
    <div className={styles.pagesWrapper}>
      {routes.map(({ name, path, logo }) => (
        <Link key={path} href={path}>
          <div
            className={cn(styles.page, {
              [styles.active]: router.pathname === path,
            })}
          >
            <img
              src={`/assets/header/${logo}.png`}
              alt={name}
              width={18}
              height={18}
            />
            <span className={styles.pageName}> {name}</span>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default HeaderLInks;
